const getCurrencyId = (currency) => {
  const currencyMap = {
    USD: 2,
    GBP: 8,
    INR: 1,
  };
  
  return currencyMap[currency.defaultValue] || 1; // Default to 1 if currency is not found
};

export default getCurrencyId;
